module.exports = __webpack_public_path__ + "static/img/null.b6bbb89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/my/null.png
// module id = iyX/
// module chunks = 212